export default {
   LOGIN: {
      TITLE: {
         en: 'Login',
         in: 'Login'
      },
      USER_NAME: {
         en: 'user name / email',
         in: 'user name / email'
      },
      NAME:{
         en: 'Participant Name',
         in: 'Nama Peserta'
      },
      EMAIL:{  
         en: 'Input Email',
         in: 'Masukan Email'
      },
      PASSWORD: {
         en: 'password',
         in: 'kata sandi'
      },
      BUTTON: {
         LOGIN: {
            en: 'Login',
            in: 'Login'
         },
         CONFIRM:{
            en: 'Confirm',
            in: 'Konfirmasi'
         }
      }
   },
   RESET_PASSWORD: {
      TITLE: {
         en: 'Reset Password',
         in: 'Atur Ulang Kata Sandi'
      },
      TOKEN: {
         en: 'Token',
         in: 'Token'
      },
      STEP_1: {
         TITLE: {
            en: 'Get Token',
            in: 'Dapatkan Token'
         },
         DESCRIPTION: {
            en: 'Please enter your email address below and click "Get your token" button. You will receive an email which contains your token (a number) to reset your password. Please contact your administrator if you haven\'t received your email in a few minutes.',
            in: 'Masukkan email yang didaftarkan. Anda akan mendapatkan token (serentetan nomor) lewat email jika email yang Anda masukkan sudah didaftarkan di sistem. Untuk alasan keamanan, Anda tidak akan mendapatkan informasi apapun apabila email yang Anda masukkan tidak terdaftar. Silahkan menghubungi Admin'
         },
         NEXT_DESCRIPTION : {
            en: 'If you have token, you can ',
            in: 'Jika Anda sudah memiliki token, Anda bisa '
         },
         BUTTON: {
            GET_TOKEN: {
               en: 'Get Token',
               in: 'Dapatkan Token'
            }
         },
         SUCCESS: {
            en: 'Token has been seen to your email. Please wait for severals minutes. If you don\'t receive it, please check you spam mailbox. Contact your school for further assist.',
            in: 'Token berhasil dikirim ke email Anda. Setelah menunggu beberapa menit, jika Anda belum menerimanya, cek kotak spam. Hubungi sekolah Anda untuk mendapatkan bantuan lebih lanjut',
         }
      },
      STEP_2: {
         TITLE: {
            en: 'Input Token',
            in: 'Masukkan Token'
         },
         DESCRIPTION: {
            en: 'Enter the token number that we sent.',
            in: 'Masukkan nomor token yang kami kirimkan.'
         },
         BACK_DESCRIPTION: {
            en: 'If you don\'t have the token yet or your token is invalid, please ',
            in: 'Jika Anda tidak memiliki token, atau token yang Anda masukkan salah, silahkan '
         },
         BUTTON: {
            CONFIRM: {
               en: 'Validate Token and Login to system',
               in: 'Validasi Token dan Masuk ke sistem'
            }
         }
      },
   },
   MENU_SETTING: {
      LOGOUT: {
         en: 'Logout',
         in: 'Keluar'
      },
      LANGUAGE: {
         en: 'Language',
         in: 'Bahasa'
      },
      CHANGE_PASSWORD: {
        en: 'Change password',
        in: 'Ganti password'
      },
      LABEL_CHANGE_PASSWORD: {
        en: 'Input your new password',
        in: 'Masukkan password baru anda'
      },
      LABEL_CONFIRMED_CHANGE_PASSWORD: {
        en: 'Re-enter your new password',
        in: 'Masukkan ulang password baru anda'
      },
      SUCCESS_CHANGE_PASSWORD: {
        en: 'Your password has been changed',
        in: 'Password anda telah berhasil dirubah'
      }
   }
}
